import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService, UserIdService } from '@spartacus/core';
import { catchError, map, Observable, switchMap, take } from 'rxjs';
import { WarehousesRequest } from './product-inventory.model';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class ProductCheckInventoryAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
    private userIdService: UserIdService,
  ) {}

  fetch(productCode: string, requestShippingDate: string): Observable<WarehousesRequest> {
    return this.userIdService.getUserId().pipe(
      take(1),
      switchMap(userId => {
        const url = this.occEndPointService.buildUrl('productInventory', {
          urlParams: { userId, productCode, requestShippingDate },
        });

        return this.http.get(url).pipe(
          take(1),
          map((data: any) => ({
            ...this.normalize(data),
            ...successStatus,
          })),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                ...failStatus,
                message: textError,
              })),
            );
          }),
        );
      }),
    );
  }

  normalize(data: any): WarehousesRequest {
    const productInventory: WarehousesRequest = {
      warehouses: data,
    };

    return productInventory;
  }
}
